import React, {useState} from 'react';
import './style.scss';
import { FaInstagram, FaFacebook, FaWhatsapp } from 'react-icons/fa';
import { MdDehaze } from 'react-icons/md';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/logo.png';
import LogoM2 from '../../assets/images/Logo_Futuro_mobile1.png';

function Menu(){
    const [mobile, setMobile] = useState(false);
    function handleClick() {
        if(mobile === false){
            setMobile(true);
        }else{
            setMobile(false);
        }
    }
    return(
        <div className="menu">
            <div className="menu__content">
                <nav>
                    <ul>
                        <li><Link to="/futuro/empresa">A Empresa</Link></li>
                        <li><Link to="/futuro/servicos">Serviços</Link></li>
                        <li><Link to="/futuro/blog">Blog</Link></li>
                        <li><Link to="/futuro/"><img src={Logo} alt="Logo Futuro"/></Link></li>
                        <li><Link to="/futuro/indices">Índices</Link></li>
                        <li><Link to="/futuro/links">Links</Link></li>
                        <li><Link to="/futuro/contato">Contato</Link></li>
                    </ul>
                </nav>
                <div className="menu__rsociais">
                    <FaWhatsapp size={18}/>
                    <FaFacebook size={18}/>
                    <FaInstagram size={18}/>
                </div>
            </div>
            <div className="menu__mobile">
                <div className="menu__icons">
                    <Link to="/futuro"><img src={LogoM2} alt="Logo Futuro" className="igm"/></Link>
                    <MdDehaze size={28} onClick={handleClick}/>
                </div>
                <div className={mobile === true ? 'menu__select--on' : 'menu__select--off'}>
                    <nav>
                        <ul>
                            <li><Link to="/futuro/empresa">A Empresa</Link></li>
                            <li><Link to="/futuro/servicos">Serviços</Link></li>
                            <li><Link to="/futuro/blog">Blog</Link></li>
                            <li><Link to="/futuro/indices">Índices</Link></li>
                            <li><Link to="/futuro/links">Links</Link></li>
                            <li><Link to="/futuro/contato">Contato</Link></li>
                        </ul>
                    </nav>
                    <div className="menu__rsociais">
                        <FaWhatsapp size={18}/>
                        <FaFacebook size={18}/>
                        <FaInstagram size={18}/>
                    </div>
                </div>
                
            </div>
        </div>
    )
}
export default Menu;